import { css } from '@microsoft/fast-element';
import { neutralForegroundRest, getToken } from '../../design-tokens';
import { spacingNumber } from '../../styles/size';
import { display } from '../../foundation/display';

export const radioGroupStyles = css`
    ${display("flex")} :host {
        align-items: flex-start;
        margin: calc(${getToken('space-design-unit')} * 1px) 0;
        flex-direction: column;
        color: ${neutralForegroundRest};
    }

    .positioning-region {
        display: flex;
        flex-wrap: wrap;
        gap: calc(${spacingNumber} * 1px);
    }

    :host([orientation="vertical"]) .positioning-region {
        flex-direction: column;
    }

    :host([orientation="horizontal"]) .positioning-region {
        flex-direction: row;
    }
`;
